import VillaItem from "./VillaItem";

export default VillaItem ;